<template>
  <Field
    :label="label"
    :type="'select'"
    :id="id"
    :name="name"
    :disabled="disabled"
    :readonly="readonly"
    :placeholder="placeholder"
    :validate="validate"
    :validateAs="validateAs"
    :errorText="errorText"
    :helpText="helpText"
    :elementClass="elementClass"
    :labelClass="labelClass"
    :inputClass="inputClass"
    :options="options"
    v-model="input"
  />
</template>

<script>
import InputFieldProps from "mixins/InputFieldProps";
export default {
  mixins: [InputFieldProps],
  props: {
    value: { type: String },
  },
  data() {
    return {
      input: this.value,
    };
  },
  computed: {
    options() {
      let options = [];
      for (var h = 0; h < 24; h++) {
        var m = 0;
        while (m < 60) {
          var value = this.$moment().hour(h).minute(m).format("HH:mm");
          var label = this.$moment().hour(h).minute(m).format("hh:mm A");
          options.push({ label: label, value: value });
          m += 15;
        }
      }
      return options;
    },
  },
  watch: {
    value(val) {
      this.input = `${val}`.substr(0, 5);
    },
    input(val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    this.input = `${this.value}`.substr(0, 5);
  },
};
</script>